var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { getGlobalSettingsSelector } from './global-settings.reducer';
import { UpdateGlobalSettingsAction } from './global-settings.actions';
import { ProjectsService } from '../projects/projects.service';
import { ToastrService } from 'ngx-toastr';
import { isEmptyOrValidPhoneNumber } from '../../shared/utils/validate-number';
import { VerifyPhoneNumberService } from '../../shared/verify-phone-number/verify-phone-number.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalSettingsFormValidator } from './ip-exclusion/GlobalSettingsFormValidator';
var GlobalSettingsComponent = /** @class */ (function () {
    function GlobalSettingsComponent(projectsService, fb, store, toastr, verifyPhoneNumberService, translate) {
        this.projectsService = projectsService;
        this.fb = fb;
        this.store = store;
        this.toastr = toastr;
        this.verifyPhoneNumberService = verifyPhoneNumberService;
        this.translate = translate;
        this.isPhoneNumberVerificationSent = false;
        this.isVerifiedPhoneNumber = true;
        this.minValue = 0;
        this.maxValue = 999;
    }
    GlobalSettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.projectsService
            .allProjects()
            .map(function (projects) {
            return projects.length > 0;
        })
            .subscribe(function (projectsExists) { return (_this.projectsExists = projectsExists); });
        this.store.select(getGlobalSettingsSelector).subscribe(function (data) {
            _this.globalSettings = data;
        });
        this.initForm();
        this.verifiedPhoneNumber = this.globalSettings.newLeadPhoneNumber;
    };
    Object.defineProperty(GlobalSettingsComponent.prototype, "isDailySummaryEnabled", {
        get: function () {
            return this.settingsForm.get('dailySummaryEnabled').value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GlobalSettingsComponent.prototype, "isNewLeadEmailEnabled", {
        get: function () {
            return this.settingsForm.get('newLeadEmailEnabled').value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GlobalSettingsComponent.prototype, "isNewLeadSmsEnabled", {
        get: function () {
            return this.settingsForm.get('newLeadSmsEnabled').value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GlobalSettingsComponent.prototype, "newLeadPhoneNumber", {
        get: function () {
            return this.settingsForm.get('newLeadPhoneNumber').value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GlobalSettingsComponent.prototype, "isGoogleAnalyticsIntegrationEnabled", {
        get: function () {
            return this.settingsForm.get('googleAnalyticsEnabled').value;
        },
        enumerable: true,
        configurable: true
    });
    GlobalSettingsComponent.prototype.initForm = function () {
        this.settingsForm = this.fb.group({
            popupDisplayLimit: [
                this.globalSettings.popupDisplayLimit,
                [Validators.min(this.minValue), Validators.max(this.maxValue)]
            ],
            dailySummaryEnabled: [this.globalSettings.dailySummaryEnabled],
            dailySummaryEmail: [this.globalSettings.dailySummaryEmail, Validators.email],
            dailySummaryTimeZone: [this.globalSettings.dailySummaryTimeZone],
            newLeadEmailEnabled: [this.globalSettings.newLeadEmailEnabled],
            newLeadEmail: [this.globalSettings.newLeadEmail, [Validators.email]],
            newLeadSmsEnabled: [this.globalSettings.newLeadSmsEnabled],
            newLeadPhoneNumber: [this.globalSettings.newLeadPhoneNumber, this.validatePhoneNumber],
            googleAnalyticsEnabled: [this.globalSettings.googleAnalyticsEnabled],
            googleAnalyticsUaTrackerId: [this.globalSettings.googleAnalyticsUaTrackerId, Validators.pattern(/^UA-\d+-\d+$/)]
        }, { validator: GlobalSettingsFormValidator });
    };
    Object.defineProperty(GlobalSettingsComponent.prototype, "isFormValid", {
        get: function () {
            return this.settingsForm.valid;
        },
        enumerable: true,
        configurable: true
    });
    GlobalSettingsComponent.prototype.validatePhoneNumber = function (control) {
        return control.parent && isEmptyOrValidPhoneNumber(control.parent.get('newLeadPhoneNumber').value)
            ? null
            : { phoneNumber: true };
    };
    Object.defineProperty(GlobalSettingsComponent.prototype, "isValidPhoneNumber", {
        get: function () {
            return this.newLeadPhoneNumber && this.settingsForm.get('newLeadPhoneNumber').valid;
        },
        enumerable: true,
        configurable: true
    });
    GlobalSettingsComponent.prototype.onPhoneNumberChange = function () {
        this.isVerifiedPhoneNumber = this.newLeadPhoneNumber === this.verifiedPhoneNumber;
    };
    Object.defineProperty(GlobalSettingsComponent.prototype, "isValidPhoneNumberVerify", {
        get: function () {
            return !this.isNewLeadSmsEnabled || (this.isNewLeadSmsEnabled && this.isVerifiedPhoneNumber);
        },
        enumerable: true,
        configurable: true
    });
    GlobalSettingsComponent.prototype.onPhoneNumberVerify = function () {
        var _this = this;
        this.verifyPhoneNumberService.sendCode(this.newLeadPhoneNumber).subscribe(function () {
            _this.isPhoneNumberVerificationSent = true;
        });
    };
    GlobalSettingsComponent.prototype.onVerificationCodeChange = function (verificationCode) {
        this.phoneNumberVerificationCode = verificationCode;
    };
    GlobalSettingsComponent.prototype.onPhoneNumberVerificationCodeVerify = function () {
        var _this = this;
        this.verifyPhoneNumberService
            .verifyCode(this.newLeadPhoneNumber, this.phoneNumberVerificationCode)
            .subscribe(function () {
            _this.translate.get('LEAD_GENERATION.TOAST.PHONE_NUMBER_VERIFIED').subscribe(function (res) {
                _this.toastr.success(res);
            });
            _this.isVerifiedPhoneNumber = true;
            _this.isPhoneNumberVerificationSent = false;
            _this.verifiedPhoneNumber = _this.newLeadPhoneNumber;
        });
    };
    GlobalSettingsComponent.prototype.onSubmit = function () {
        var _this = this;
        // when form is not valid the scrollToFirstInvalidField directive will be used
        if (this.isFormValid && this.isValidPhoneNumberVerify) {
            var formSettings = this.settingsForm.getRawValue();
            var updatedGlobalSettings = __assign({}, this.globalSettings, formSettings);
            this.store.dispatch(new UpdateGlobalSettingsAction(updatedGlobalSettings));
            this.translate.get('LEAD_GENERATION.TOAST.GLOBAL_SETTINGS_UPDATED').subscribe(function (res) {
                _this.toastr.success(res);
            });
        }
    };
    return GlobalSettingsComponent;
}());
export { GlobalSettingsComponent };
